<template>

<nav class="navbar" role="navigation" aria-label="main navigation">
  <div class="navbar-brand">
    <a class="navbar-item" href="https://danvonfeldt.com">
      <img src="./../assets/logo.png">
    </a>

  </div>

</nav>

</template>

<script>
export default {
  name: 'Header',
  props: {
    siteName: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
